<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    :size="data.size || 'md'"
    :title="_trans('Render Farm Manager')"
    :centered="data.centered || false"
    :scrollable="data.scrollable || false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template slot="modal-header-close">
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <input
      v-model="renderName"
      type="text"
      class="form-control"
      :placeholder="_trans('Render name')"
      @keyup.enter="sendRender"
    />
        <b-row class="mt-3">
          <div class="form-inline form-group col">
            <label>
              <b-form-radio v-model="renderType" class="radio-inline" :value="1" />
              <span v-text="_trans('Static image')"></span>
            </label>
          </div>
          <div class="form-inline form-group col">
            <label>
              <b-form-radio v-model="renderType" class="radio-inline" :value="3" />
              <span v-text="_trans('Panorama')"></span>
            </label>
          </div>
        </b-row>
    <div slot="modal-footer">
      <b-button
        variant="primary"
        @click="sendRender()"
        v-html="_trans('Send render')"
      ></b-button>
    </div>
  </b-modal>
</template>
<script>
import { NextApiClient, RenderFarmAPI } from '@3cad/nextcore';
import { OAuth2 } from '@3cad/dau-auth-library';
import { bus } from "@store/dau";
import { rfMovement, rfUser } from "@facades/RenderFarm";
import { User } from "@3cad/renderfarmapi";
import modal from "@dialogs/modal.vue";
export default {
    mixins: [modal],
    data() {
        return {
            renderList: { data: [] },
            message: "System Ready",
            percent: 0,
            renderName: '',
            rfToken: null,
            renderType: 1
        };
    },
    computed: {
        preferences() {
            return this.$store.getters['getPreferences'];
        },
        messageData() {
            return this.message;
        },
        renderData() {
            return this.renderList.data
        },
        user () {
            return this.$store.getters['getProfile']
        },
        hiddenLogin() {
            if(this.preferences && this.preferences.config) {
                return !!this.preferences.config.rfAuthHidden;
            }
            else
                return false
        }
    },
    methods: {
        sendFile(token, guid, name, content) {
            return new Promise((resolve, reject) => {

                let body = {
                    filename: name,
                    json: content
                };

                rfMovement.movementGuidUploadJSONPost(token, guid, body,(err, data, res) => {
                    if(err) {
                        let errJson = JSON.parse(res.text);
                        if(res.status === 401 && errJson.internal_error === 2) {
                            this.loginToRF().then(() => {
                                this.sendFile(this.rfToken, guid, name, content).then(resolve).catch(reject);
                            }).catch(() => {
                                reject(errJson);
                            })
                        }
                        else
                            reject(errJson);
                    }
                    else
                        resolve(data)
                    }
                )
            });
        },
        createMovement(token, tokenSoftware) {
            return new Promise((resolve, reject) => {

                let body = {
                    des: this.renderName || 'untitled',
                    type: this.renderType,
                    project: this.data.prjId
                };

                rfMovement.movementNameCreateMovementPost(token, tokenSoftware, body, (err, data, res) => {
                        if(err) {
                            let errJson = JSON.parse(res.text);
                            if(res.status === 401 && errJson.internal_error === 2) {
                                this.loginToRF().then(() => {
                                    this.createMovement(this.rfToken, tokenSoftware).then(resolve).catch(reject);
                                }).catch(() => {
                                    reject(errJson);
                                })
                            }
                            else
                                reject(errJson);
                        }
                        else
                            resolve(data);
                    }
                )
            });
        },
        beginRender(token, GUID) {
            return new Promise((resolve, reject) => {
                rfMovement.movementGuidNamestartMovementRenderPost(
                    token,
                    GUID,
                    (err, data, res) => {
                        if(err) {
                            let errJson = JSON.parse(res.text);
                            if(res.status === 401 && errJson.internal_error === 2) {
                                this.loginToRF().then(() => {
                                    this.beginRender(this.rfToken, GUID).then(resolve).catch(reject);
                                }).catch(() => {
                                    reject(errJson);
                                })
                            }
                            else
                                reject(errJson);
                        }
                        else
                            resolve(data);
                    }
                )
            });
        },
        /*retrieveTokenNext(uid, pwd) {
            return new Promise((resolve, reject) => {
                RenderFarmAPI.getRFCreationToken(this.user.userName, pwd, resolve, reject);
                /!*NextApiClient.com('@3cad/renderfarmapi', 'jUserCreationToken', { _UID: uid, userPwd: pwd }, resp => {
                    resolve(resp);
                });*!/
            })
        },*/
        loginToRF () {
            return new Promise((resolve, reject) => {
                if (this.user.userName && this._validEmail(this.user.userName)) {

                    RenderFarmAPI.jRfToken( tokenSoftware => {

                        if(tokenSoftware && tokenSoftware.checkSum) {
                            let user4RF = new User(this.user.userName);
                            rfUser.userNameRSALoginPost(tokenSoftware.checkSum, user4RF, (err, data, res) => {
                                if (err)
                                    reject(err);
                                else {
                                    NextApiClient.setRfToken(data.access_token);
                                    this.rfToken = NextApiClient.getRfToken();
                                    resolve(this.rfToken);
                                }
                            });
                        }
                        else
                            reject(new Error('Missing token from service'))
                    }, reject);
                } else
                    reject('User name is not an email')
            })
        },
        sendRender() {
            if(this.rfToken) {
                RenderFarmAPI.jRfToken(
                    tokenSoftware => {
                        this.close(1)
                        bus.$emit('startLoading', this._trans('Sending render'))
                        this.createMovement(this.rfToken, tokenSoftware.checkSum)
                            .then(
                                response => {
                                    let extras = this.$store.state.cad.iCad
                                        .get3D()
                                        // TODO: Get canvas proportions
                                        .getExtraForRendering(2160, 2160, this.renderType)

                                    RenderFarmAPI.jRenderProject(
                                        this.$store.state.project,
                                        extras,
                                        resp => {
                                            this.sendFile(
                                                this.rfToken,
                                                response.guid,
                                                'scene.json',
                                                JSON.stringify(resp)
                                            ).then(resp => {
                                                let guid = response.guid
                                                this.beginRender(this.rfToken, guid).then(resp => {
                                                    bus.$emit('stopLoading')
                                                }).catch(err => { bus.$emit('stopLoading') })
                                            })
                                        }, err => {
                                            bus.$emit('stopLoading')
                                            throw err
                                        })
                                })
                            .catch(err => {
                                bus.$emit('stopLoading')
                                throw err
                            })
                    }, err => {
                        throw err;
                    });
            }
            else if(this.preferences.config && this.preferences.config.rfAuthHidden) {
                this.loginToRF().then(() => {
                    RenderFarmAPI.jRfToken(
                        tokenSoftware => {
                            this.close(1)
                            bus.$emit('startLoading', this._trans('Sending render'))
                            this.createMovement(this.rfToken, tokenSoftware.checkSum)
                                .then(
                                    response => {
                                        console.log('this.renderType', this.renderType)
                                        let extras = this.$store.state.cad.iCad
                                            .get3D()
                                            // TODO: Get canvas proportions
                                            .getExtraForRendering(2160, 2160, this.renderType)

                                        RenderFarmAPI.jRenderProject(
                                            this.$store.state.project,
                                            extras,
                                            resp => {
                                                this.sendFile(
                                                    this.rfToken,
                                                    response.guid,
                                                    'scene.json',
                                                    JSON.stringify(resp)
                                                ).then(resp => {
                                                    let guid = response.guid
                                                    this.beginRender(this.rfToken, guid).then(resp => {
                                                        bus.$emit('stopLoading')
                                                    }).catch(err => { bus.$emit('stopLoading') })
                                                })
                                            }, err => {
                                                bus.$emit('stopLoading')
                                                throw err
                                            })
                                    })
                                .catch(err => {
                                    bus.$emit('stopLoading')
                                    throw err
                                })
                        }, err => {
                            throw err;
                        });
                }).catch( err => {
                    throw err;
                });
            }
        },
        navigateOnImage(renderId) {
            this.$store.state.cad.iCad.get3D().rfGetURL(
                RenderFarmAPI,
                renderId,
                function(res) {
                    window.open(res, "_blank");
                },
                function(err) {
                    this.message = "Error : " + err;
                }
            );
        },
        onShow() {
            this.rfToken = NextApiClient.getRfToken();
            if(!this.rfToken) {
                if(this.hiddenLogin) {
                } else {
                    let redirectUrl = window.location.origin + (window.location.origin.indexOf('localhost') < 0 ? window.location.pathname : '');
                    this.OAuth = new OAuth2(
                        "aaa-bbb-ccc",
                        redirectUrl,
                        token => {
                            rfUser.userOauth2Get(token, (error, data, resp) => {

                                if(error) {
                                    alert(JSON.stringify(error));
                                    throw 'Error: '+ resp;
                                }

                                NextApiClient.setRfToken(data.access_token);
                                this.rfToken = NextApiClient.getRfToken();
                            })
                        }
                    );
                    this.OAuth.launchAuthWindow();
                }
            }
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/app/dialogs/modalRenderfarm.vue